// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#main.store-operations {
  padding: 14px;
}

.store-operations {
  min-height: calc(100vh - 48px);
  background: radial-gradient(circle at top right, rgba(11, 87, 183, 0.08), transparent 28%), #f4f7fb;
}
.store-operations__shell {
  width: 100%;
  margin: 0 auto;
}
.store-operations__header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}
.store-operations__header h1 {
  margin: 2px 0 4px;
  color: #172033;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.4px;
}
.store-operations__header p {
  margin: 0;
  color: #667085;
  font-size: 13px;
}
.store-operations__header-icon {
  display: grid;
  width: 48px;
  height: 48px;
  flex: 0 0 48px;
  place-items: center;
  border-radius: 14px;
  color: #ffffff;
  background: linear-gradient(145deg, #0b57b7, #08438e);
  box-shadow: 0 8px 20px rgba(11, 87, 183, 0.22);
  font-size: 22px;
}
.store-operations__eyebrow {
  color: #0b57b7;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
}
.store-operations__tabs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  padding: 7px;
  border: 1px solid #dce5f0;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 6px 24px rgba(21, 45, 78, 0.07);
}
.store-operations__tab {
  display: flex;
  min-height: 68px;
  align-items: center;
  gap: 13px;
  padding: 11px 16px;
  border: 1px solid transparent;
  border-radius: 11px;
  color: #172033;
  background: transparent;
  text-align: left;
  transition: border-color 160ms ease, background-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}
.store-operations__tab:hover {
  border-color: #c9d9ec;
  background: #f7faff;
}
.store-operations__tab:focus-visible {
  outline: 3px solid rgba(11, 87, 183, 0.2);
  outline-offset: 2px;
}
.store-operations__tab--active {
  border-color: rgba(11, 87, 183, 0.22);
  color: #08438e;
  background: linear-gradient(135deg, #edf5ff 0%, #f7fbff 100%);
  box-shadow: inset 3px 0 0 #0b57b7;
}
.store-operations__tab--active .store-operations__tab-icon {
  color: #ffffff;
  background: #0b57b7;
  box-shadow: 0 5px 12px rgba(11, 87, 183, 0.2);
}
.store-operations__tab--active .store-operations__tab-arrow {
  color: #0b57b7;
  transform: translateX(2px);
}
.store-operations__tab-icon {
  display: grid;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  place-items: center;
  border-radius: 10px;
  color: #0b57b7;
  background: #eaf2fc;
  font-size: 17px;
  transition: color 160ms ease, background-color 160ms ease;
}
.store-operations__tab-copy {
  display: flex;
  min-width: 0;
  flex: 1 1;
  flex-direction: column;
  gap: 2px;
}
.store-operations__tab-copy strong {
  font-size: 16px;
  font-weight: 650;
}
.store-operations__tab-copy small {
  overflow: hidden;
  color: #667085;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.store-operations__tab-arrow {
  color: #98a2b3;
  font-size: 13px;
  transition: color 160ms ease, transform 160ms ease;
}
.store-operations__content {
  overflow: hidden;
  margin-top: 16px;
  border: 1px solid #dce5f0;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(21, 45, 78, 0.08);
  padding: 0px 16px;
}
.store-operations__content > .dashboard,
.store-operations__content > .generatejobcard {
  padding: 0;
  background: #ffffff;
}
.store-operations__content .subContent {
  margin: 0 !important;
  padding: 22px 24px 12px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfcfe 100%);
}
.store-operations__content .mainTitle {
  color: #172033;
  font-size: 21px;
  letter-spacing: -0.25px;
}
.store-operations__content .subText {
  color: #667085;
}
.store-operations__content .wire-trace-header {
  align-items: center;
}
.store-operations__content .wire-trace-header__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}
.store-operations__content .wire-trace-header__update {
  display: grid;
  width: min(100%, 410px);
  grid-template-columns: minmax(190px, 1fr) auto;
  gap: 0;
  margin: 0;
  padding: 9px 10px 10px;
  border: 1px solid #d8e4f1;
  border-radius: 12px;
  background: #f7faff;
  box-shadow: 0 4px 14px rgba(21, 45, 78, 0.06);
}
.store-operations__content .wire-trace-header__update .form-label {
  display: flex;
  grid-column: 1/-1;
  align-items: center;
  gap: 6px;
  margin: 0 0 7px;
  color: #172033;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}
.store-operations__content .wire-trace-header__update .form-label i {
  color: #0b57b7;
  font-size: 13px;
}
.store-operations__content .wire-trace-header__update .form-control {
  height: 38px;
  border-color: #d7e1ed;
  border-radius: 8px 0 0 8px;
  background: #ffffff;
  font-size: 12px;
}
.store-operations__content .wire-trace-header__update .form-control:focus {
  border-color: #0b57b7;
  box-shadow: 0 0 0 3px rgba(11, 87, 183, 0.12);
}
.store-operations__content .wire-trace-header__update .btn {
  height: 38px;
  min-width: 92px;
  padding: 0 15px;
  border-radius: 0 8px 8px 0;
  font-size: 12px;
  font-weight: 700;
}
.store-operations__content .wire-trace-header__filter {
  display: grid;
  width: 46px;
  height: 46px;
  flex: 0 0 46px;
  place-items: center;
  padding: 0;
  border-radius: 10px;
  box-shadow: 0 5px 12px rgba(11, 87, 183, 0.16);
}
.store-operations__content .wire-trace-header hr {
  margin-top: 18px;
  margin-bottom: 0;
}

@media (max-width: 767px) {
  #main.store-operations {
    padding: 14px;
  }
  .store-operations__header {
    align-items: flex-start;
  }
  .store-operations__header h1 {
    font-size: 22px;
  }
  .store-operations__tabs {
    grid-template-columns: 1fr;
  }
  .store-operations__tab {
    min-height: 62px;
  }
  .store-operations__content {
    border-radius: 13px;
  }
  .store-operations__content .subContent {
    padding: 18px 14px 10px;
  }
  .store-operations__content .wire-trace-header__actions {
    align-items: center;
    justify-content: flex-start;
    margin-top: 14px;
  }
  .store-operations__content .wire-trace-header__update {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .store-operations__content .wire-trace-header__actions {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 44px;
  }
  .store-operations__content .wire-trace-header__update {
    grid-template-columns: minmax(0, 1fr) auto;
    padding-left: 6px;
  }
  .store-operations__content .wire-trace-header__update .form-label {
    display: none;
  }
  .store-operations__content .wire-trace-header__filter {
    width: 44px;
    height: 48px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/manufacturing_app/StoreOperations.scss"],"names":[],"mappings":"AAQA;EACE,aAAA;AAPF;;AAUA;EACE,8BAAA;EACA,mGACE;AARJ;AAWE;EACE,WAAA;EACA,cAAA;AATJ;AAYE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAVJ;AAYI;EACE,iBAAA;EACA,cA1BO;EA2BP,eAAA;EACA,gBAAA;EACA,sBAAA;AAVN;AAaI;EACE,SAAA;EACA,cAjCQ;EAkCR,eAAA;AAXN;AAeE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,qDAAA;EACA,8CAAA;EACA,eAAA;AAbJ;AAgBE;EACE,cA1DY;EA2DZ,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AAdJ;AAiBE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,qCAAA;EACA,6CAAA;AAfJ;AAkBE;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,cA/ES;EAgFT,uBAAA;EACA,gBAAA;EACA,6GAAA;AAhBJ;AAmBI;EACE,qBAAA;EACA,mBAAA;AAjBN;AAoBI;EACE,yCAAA;EACA,mBAAA;AAlBN;AAqBI;EACE,qCAAA;EACA,cArGe;EAsGf,6DAAA;EACA,iCAAA;AAnBN;AAqBM;EACE,cAAA;EACA,mBA5GQ;EA6GR,6CAAA;AAnBR;AAsBM;EACE,cAjHQ;EAkHR,0BAAA;AApBR;AAyBE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,cA9HY;EA+HZ,mBAAA;EACA,eAAA;EACA,yDAAA;AAvBJ;AA0BE;EACE,aAAA;EACA,YAAA;EACA,SAAA;EACA,sBAAA;EACA,QAAA;AAxBJ;AA0BI;EACE,eAAA;EACA,gBAAA;AAxBN;AA2BI;EACE,gBAAA;EACA,cA5IQ;EA6IR,eAAA;EACA,uBAAA;EACA,mBAAA;AAzBN;AA6BE;EACE,cAAA;EACA,eAAA;EACA,kDAAA;AA3BJ;AA8BE;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAlKY;EAmKZ,8CAAA;EACA,iBAAA;AA5BJ;AA6BI;;EAEE,UAAA;EACA,mBAxKU;AA6IhB;AA8BI;EACE,oBAAA;EACA,uBAAA;EACA,6DAAA;AA5BN;AA+BI;EACE,cA/KO;EAgLP,eAAA;EACA,uBAAA;AA7BN;AAgCI;EACE,cApLQ;AAsJd;AAiCI;EACE,mBAAA;AA/BN;AAiCM;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;AA/BR;AAkCM;EACE,aAAA;EACA,uBAAA;EACA,8CAAA;EACA,MAAA;EACA,SAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6CAAA;AAhCR;AAkCQ;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cApNG;EAqNH,eAAA;EACA,gBAAA;EACA,cAAA;AAhCV;AAkCU;EACE,cA/NI;EAgOJ,eAAA;AAhCZ;AAoCQ;EACE,YAAA;EACA,qBAAA;EACA,0BAAA;EACA,mBAAA;EACA,eAAA;AAlCV;AAoCU;EACE,qBA5OI;EA6OJ,6CAAA;AAlCZ;AAsCQ;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;AApCV;AAwCM;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,8CAAA;AAtCR;AAyCM;EACE,gBAAA;EACA,gBAAA;AAvCR;;AA6CA;EACE;IACE,aAAA;EA1CF;EA8CE;IACE,uBAAA;EA5CJ;EA8CI;IACE,eAAA;EA5CN;EAgDE;IACE,0BAAA;EA9CJ;EAiDE;IACE,gBAAA;EA/CJ;EAkDE;IACE,mBAAA;EAhDJ;EAkDI;IACE,uBAAA;EAhDN;EAoDM;IACE,mBAAA;IACA,2BAAA;IACA,gBAAA;EAlDR;EAqDM;IACE,WAAA;EAnDR;AACF;AAyDA;EAEI;IACE,aAAA;IACA,0CAAA;EAxDJ;EA2DE;IACE,0CAAA;IACA,iBAAA;EAzDJ;EA2DI;IACE,aAAA;EAzDN;EA6DE;IACE,WAAA;IACA,YAAA;EA3DJ;AACF","sourcesContent":["$store-primary: #0b57b7;\n$store-primary-dark: #08438e;\n$store-surface: #ffffff;\n$store-background: #f4f7fb;\n$store-border: #dce5f0;\n$store-text: #172033;\n$store-muted: #667085;\n\n#main.store-operations {\n  padding: 14px;\n}\n\n.store-operations {\n  min-height: calc(100vh - 48px);\n  background:\n    radial-gradient(circle at top right, rgba(11, 87, 183, 0.08), transparent 28%),\n    $store-background;\n\n  &__shell {\n    width: 100%;\n    margin: 0 auto;\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 20px;\n\n    h1 {\n      margin: 2px 0 4px;\n      color: $store-text;\n      font-size: 26px;\n      font-weight: 700;\n      letter-spacing: -0.4px;\n    }\n\n    p {\n      margin: 0;\n      color: $store-muted;\n      font-size: 13px;\n    }\n  }\n\n  &__header-icon {\n    display: grid;\n    width: 48px;\n    height: 48px;\n    flex: 0 0 48px;\n    place-items: center;\n    border-radius: 14px;\n    color: #ffffff;\n    background: linear-gradient(145deg, $store-primary, $store-primary-dark);\n    box-shadow: 0 8px 20px rgba(11, 87, 183, 0.22);\n    font-size: 22px;\n  }\n\n  &__eyebrow {\n    color: $store-primary;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 1.2px;\n    text-transform: uppercase;\n  }\n\n  &__tabs {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 10px;\n    padding: 7px;\n    border: 1px solid $store-border;\n    border-radius: 16px;\n    background: rgba(255, 255, 255, 0.92);\n    box-shadow: 0 6px 24px rgba(21, 45, 78, 0.07);\n  }\n\n  &__tab {\n    display: flex;\n    min-height: 68px;\n    align-items: center;\n    gap: 13px;\n    padding: 11px 16px;\n    border: 1px solid transparent;\n    border-radius: 11px;\n    color: $store-text;\n    background: transparent;\n    text-align: left;\n    transition: border-color 160ms ease, background-color 160ms ease,\n      box-shadow 160ms ease, transform 160ms ease;\n\n    &:hover {\n      border-color: #c9d9ec;\n      background: #f7faff;\n    }\n\n    &:focus-visible {\n      outline: 3px solid rgba(11, 87, 183, 0.2);\n      outline-offset: 2px;\n    }\n\n    &--active {\n      border-color: rgba(11, 87, 183, 0.22);\n      color: $store-primary-dark;\n      background: linear-gradient(135deg, #edf5ff 0%, #f7fbff 100%);\n      box-shadow: inset 3px 0 0 $store-primary;\n\n      .store-operations__tab-icon {\n        color: #ffffff;\n        background: $store-primary;\n        box-shadow: 0 5px 12px rgba(11, 87, 183, 0.2);\n      }\n\n      .store-operations__tab-arrow {\n        color: $store-primary;\n        transform: translateX(2px);\n      }\n    }\n  }\n\n  &__tab-icon {\n    display: grid;\n    width: 38px;\n    height: 38px;\n    flex: 0 0 38px;\n    place-items: center;\n    border-radius: 10px;\n    color: $store-primary;\n    background: #eaf2fc;\n    font-size: 17px;\n    transition: color 160ms ease, background-color 160ms ease;\n  }\n\n  &__tab-copy {\n    display: flex;\n    min-width: 0;\n    flex: 1;\n    flex-direction: column;\n    gap: 2px;\n\n    strong {\n      font-size: 16px;\n      font-weight: 650;\n    }\n\n    small {\n      overflow: hidden;\n      color: $store-muted;\n      font-size: 11px;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  &__tab-arrow {\n    color: #98a2b3;\n    font-size: 13px;\n    transition: color 160ms ease, transform 160ms ease;\n  }\n\n  &__content {\n    overflow: hidden;\n    margin-top: 16px;\n    border: 1px solid $store-border;\n    border-radius: 16px;\n    background: $store-surface;\n    box-shadow: 0 10px 30px rgba(21, 45, 78, 0.08);\n    padding: 0px 16px;\n    > .dashboard,\n    > .generatejobcard {\n      padding: 0;\n      background: $store-surface;\n    }\n\n    .subContent {\n      margin: 0 !important;\n      padding: 22px 24px 12px;\n      background: linear-gradient(180deg, #ffffff 0%, #fbfcfe 100%);\n    }\n\n    .mainTitle {\n      color: $store-text;\n      font-size: 21px;\n      letter-spacing: -0.25px;\n    }\n\n    .subText {\n      color: $store-muted;\n    }\n\n    .wire-trace-header {\n      align-items: center;\n\n      &__actions {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        gap: 10px;\n      }\n\n      &__update {\n        display: grid;\n        width: min(100%, 410px);\n        grid-template-columns: minmax(190px, 1fr) auto;\n        gap: 0;\n        margin: 0;\n        padding: 9px 10px 10px;\n        border: 1px solid #d8e4f1;\n        border-radius: 12px;\n        background: #f7faff;\n        box-shadow: 0 4px 14px rgba(21, 45, 78, 0.06);\n\n        .form-label {\n          display: flex;\n          grid-column: 1 / -1;\n          align-items: center;\n          gap: 6px;\n          margin: 0 0 7px;\n          color: $store-text;\n          font-size: 12px;\n          font-weight: 700;\n          line-height: 1;\n\n          i {\n            color: $store-primary;\n            font-size: 13px;\n          }\n        }\n\n        .form-control {\n          height: 38px;\n          border-color: #d7e1ed;\n          border-radius: 8px 0 0 8px;\n          background: #ffffff;\n          font-size: 12px;\n\n          &:focus {\n            border-color: $store-primary;\n            box-shadow: 0 0 0 3px rgba(11, 87, 183, 0.12);\n          }\n        }\n\n        .btn {\n          height: 38px;\n          min-width: 92px;\n          padding: 0 15px;\n          border-radius: 0 8px 8px 0;\n          font-size: 12px;\n          font-weight: 700;\n        }\n      }\n\n      &__filter {\n        display: grid;\n        width: 46px;\n        height: 46px;\n        flex: 0 0 46px;\n        place-items: center;\n        padding: 0;\n        border-radius: 10px;\n        box-shadow: 0 5px 12px rgba(11, 87, 183, 0.16);\n      }\n\n      hr {\n        margin-top: 18px;\n        margin-bottom: 0;\n      }\n    }\n  }\n}\n\n@media (max-width: 767px) {\n  #main.store-operations {\n    padding: 14px;\n  }\n\n  .store-operations {\n    &__header {\n      align-items: flex-start;\n\n      h1 {\n        font-size: 22px;\n      }\n    }\n\n    &__tabs {\n      grid-template-columns: 1fr;\n    }\n\n    &__tab {\n      min-height: 62px;\n    }\n\n    &__content {\n      border-radius: 13px;\n\n      .subContent {\n        padding: 18px 14px 10px;\n      }\n\n      .wire-trace-header {\n        &__actions {\n          align-items: center;\n          justify-content: flex-start;\n          margin-top: 14px;\n        }\n\n        &__update {\n          width: 100%;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .store-operations__content .wire-trace-header {\n    &__actions {\n      display: grid;\n      grid-template-columns: minmax(0, 1fr) 44px;\n    }\n\n    &__update {\n      grid-template-columns: minmax(0, 1fr) auto;\n      padding-left: 6px;\n\n      .form-label {\n        display: none;\n      }\n    }\n\n    &__filter {\n      width: 44px;\n      height: 48px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
